import { useMemo } from 'react'
import { View } from 'react-native'
import { useAuth } from '../lib/AuthContext'
import { useThemeColors } from '../lib/useThemeColors'
import { resolvePerson } from '../lib/personAvatar'
import PersonAvatar from './PersonAvatar'
import { lighten } from './personAvatarConfig'
import { useShowAvatars } from '../lib/avatarPref'

/**
 * PersonAvatarBust — busto dell'avatar (testa e spalle con la maglia), per chi veste una maglia speciale.
 * Come in Home: l'avatar indossa la maglia di classifica (colore, o pois per la GPM di Tour e Vuelta).
 *
 * Props: userId, settings (avatar_settings), jersey: { color, pattern } , width, height
 */
const HEX = /^#[0-9A-Fa-f]{6}$/
const X0 = 0.13   // ritaglio a sinistra (frazione dell'immagine)
const CROP_W = 0.747

export default function PersonAvatarBust({ userId, settings, jersey, width = 44, height = 48 }) {
  const tc = useThemeColors()
  const { user, avatarSettings } = useAuth()
  const src = user?.id === userId ? avatarSettings : settings
  const color = HEX.test(jersey?.color ?? '') ? jersey.color : tc.rosa
  const show = useShowAvatars()   // interruttore del Profilo: spento = solo il nome, niente avatar

  const person = useMemo(() => {
    const p = resolvePerson(src, userId)
    if (jersey?.pattern === 'dots') { p.jersey = 5; p.main = '#FFFFFF'; p.accent = color; p.trim = color }
    else { p.main = color; p.accent = color; p.trim = color }
    return p
  }, [src, userId, color, jersey?.pattern])

  if (!show) return null
  const size = width / CROP_W
  return (
    <View style={{ width, height, borderRadius: 10, overflow: 'hidden', backgroundColor: lighten(color, 0.82) }}>
      <View style={{ marginLeft: -size * X0 }}>
        <PersonAvatar person={person} size={size} />
      </View>
    </View>
  )
}
